import React from "react";
import IntegrationActivityLog from "../IntegrationActivityLog";

export default function NetsuiteLog() {
  return <IntegrationActivityLog integrationSlug="NetSuite" />;
}
